function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "link-icon",
  d: "M0 3C0 1.34315 1.34315 0 3 0H8C8.55228 0 9 0.447715 9 1C9 1.55228 8.55228 2 8 2H3C2.44772 2 2 2.44772 2 3V7C2 7.55228 2.44772 8 3 8H8C8.55228 8 9 8.44772 9 9C9 9.55229 8.55228 10 8 10H3C1.34315 10 0 8.65685 0 7V3Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "link-icon",
  d: "M11 1C11 0.447715 11.4477 0 12 0H17C18.6569 0 20 1.34315 20 3V7C20 8.65685 18.6569 10 17 10H12C11.4477 10 11 9.55229 11 9C11 8.44772 11.4477 8 12 8H17C17.5523 8 18 7.55228 18 7V3C18 2.44772 17.5523 2 17 2H12C11.4477 2 11 1.55228 11 1Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "link-icon",
  d: "M5.5 4C4.94772 4 4.5 4.44772 4.5 5C4.5 5.55228 4.94772 6 5.5 6H14.5C15.0523 6 15.5 5.55228 15.5 5C15.5 4.44772 15.0523 4 14.5 4H5.5Z"
});

function SvgExternalLinkIconWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkIconWhite);
export default __webpack_public_path__ + "static/media/external-link-icon-white.6c04904a.svg";
export { ForwardRef as ReactComponent };